import { Box, Divider } from "@mui/material";
import { TransForm } from "../../common/TransForm/Index";
import { PageTitle } from "../../common/PageTitle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { base_url } from '../../backendurl/url';
import emailConfigurationFormInputs from "../../common/jsons/formConfigs/emailConfigurationFormInputs";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { Notification } from "../../common/Notification";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";

export const EmailConfiguration = ({ mode, title }) => {
  const { selectedUser } = useSelector((state) => state);
  const [popup, setPopup] = useState(false);
  const { user_uuid } = useParams("user_uuid");
  const [loading, setLoading] = useState(false);
  const [emailConfig, setEmailConfig] = useState({});
  const [isupdate, setIsupdate] = useState(false);
  const [configData, setConfigData] = useState();
  const [notification, setnotification] = useState(false);
  const [successNotification, setSuccessNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');


  // Updated extractErrorMessages function
const extractErrorMessages = (errorResponse) => {
  try {
    console.log(errorResponse, "errorResponse");

    // Handle case: errorResponse.data.errors exists
    if (errorResponse?.data?.errors && Array.isArray(errorResponse.data.errors)) {
      const errorMessages = [];

      errorResponse.data.errors.forEach(errorGroup => {
        console.log(errorGroup, "errorGroup");

        // Case 1: Nested array of [field, messages]
        if (Array.isArray(errorGroup)) {
          errorGroup.forEach(([fieldName, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach(message => {
                errorMessages.push(`${fieldName}: ${message}`);
              });
            }
          });
        } 
        else if (typeof errorGroup === 'string') {
          errorMessages.push(errorGroup);
        }
      });

      return errorMessages.join('\n');
    }

    // Handle fallback: message property exists
    if (errorResponse?.data?.message) {
      return errorResponse.data.message;
    }

    if (errorResponse?.message) {
      return errorResponse.message;
    }

    return 'An error occurred while processing your request.';
  } catch (e) {
    return 'An unexpected error occurred.';
  }
};


  
  const SubmitConfig = async () => {
    try {
      const bulkUpdatePayload = {
        configurations: [
          {
            config_type: "primary_email",
            value: 0,
            description: configData.primary_email,
            is_active: true
          },
          {
            config_type: "secondary_email",
            value: 0,
            description: configData.secondary_email,
            is_active: true
          }
          // ...(configData.secondary_email ? [{
          //   config_type: "secondary_email",
          //   value: 0,
          //   description: configData.secondary_email,
          //   is_active: true
          // }] : [])
        ]
      };

      
      const url = `${base_url}/api/accounts/config/email-update/`;
      if (isupdate) {
        await axios.put(url, bulkUpdatePayload, Config);
      } else {
        await axios.post(url, bulkUpdatePayload, Config);
      }

      setPopup(false);
      setSuccessMessage('Email configuration saved successfully');
      setSuccessNotification(true);

      await getEmailConfig(); 

    } catch (error) {
      // RefreshToken(error, setErrorMessage, setnotification);
      //console.log(error?.response?.status, "Hi111")
       if (error?.response?.status === 400 && error?.response?.data) {
      const errorMsg = extractErrorMessages(error.response.data);
      setErrorMessage(errorMsg);
      setnotification(true);
    } else {
      RefreshToken(error, setErrorMessage, setnotification);
    }
    }
  };

  
  const onSubmit = async (data) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!emailRegex.test(data.primary_email)) {
      setErrorMessage('Please enter a valid primary email address');
      setnotification(true);
      return;
    }

    if (data.secondary_email && !emailRegex.test(data.secondary_email)) {
      setErrorMessage('Please enter a valid secondary email address');
      setnotification(true);
      return;
    }

    if (data.secondary_email && data.primary_email.toLowerCase() === data.secondary_email.toLowerCase()) {
      setErrorMessage('Primary and Secondary emails cannot be the same');
      setnotification(true);
      return;
    }

    delete data.Save;
    setPopup(true);
    setConfigData(data);
  };

  
  const transformApiDataToFormData = (apiData) => {
    console.log(apiData, "apiData")
    const formData = {};
    if (apiData?.email_configurations?.length) {
      apiData.email_configurations.forEach((config) => {
        if (config.config_type === "primary_email") {
          formData.primary_email = config.description || "";
        }
        if (config.config_type === "secondary_email") {
          formData.secondary_email = config.description || "";
        }
      });
    }
    return formData;
  };

  
  const getEmailConfig = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${base_url}/api/accounts/config/email-update/`, Config);
      console.log("Email Config Response:", response.data);

      const data = response.data.data || response.data;

      if (data?.email_configurations?.length > 0) {
        const transformed = transformApiDataToFormData(data);
        setEmailConfig(transformed);
        setIsupdate(true);
      } else {
        setEmailConfig({});
        setIsupdate(false);
      }

    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
    } finally {
      setLoading(false);
    }
  }, [selectedUser, user_uuid]);

  useEffect(() => {
    getEmailConfig();
  }, [getEmailConfig]);

  return (
    <Box>
      <Box sx={{ px: 6, pt: 3 }} alignContent="center">
        <PageTitle pageTitle={'Withdrawal Recipient Email Configuration'} />
      </Box>
      <Divider sx={{ mb: 2, height: 4 }} />
      <Box sx={{ px: 6 }}>
        <TransForm
          submitAction={onSubmit}
          data={emailConfig}
          mode={mode}
          cardlength={'oneCard'}
          formInputs={emailConfigurationFormInputs({ mode, isupdate })}
          clearErrorsOnChange={true}
        />
      </Box>
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={`Are you sure you want to ${isupdate ? 'update' : 'save'} the withdrawal recipient email configuration?`}
        onClick={SubmitConfig}
        save={isupdate ? 'Yes, Update' : 'Yes, Save'}
        cancel={'Cancel'}
      />
      <Notification 
        message={errorMessage} 
        setopen={setnotification} 
        type={'error'} 
        show={notification} 
      />
      <Notification 
        message={successMessage} 
        setopen={setSuccessNotification} 
        type={'success'} 
        show={successNotification} 
      />
    </Box>
  );
};

export default EmailConfiguration;
